module.exports = __webpack_public_path__ + "static/img/passageway.fdf8dd76.png";